export default __webpack_public_path__ + "static/media/tictactoe.afcee40f.png";